"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _hooks = require("../../hooks");
const Translated = _ref => {
  let {
    id,
    values
  } = _ref;
  const intl = (0, _hooks.useIntl)();
  return intl.formatMessage({
    id
  }, values);
};
var _default = exports.default = Translated;